import moment from 'moment';

export const OS_STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguard. material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguard. validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

export const OS_PRIORIDADE_LABELS = {
  BAIXA: 'Baixa',
  MEDIA: 'Média',
  ALTA: 'Alta',
  CRITICA: 'Crítica',
};

export const OS_TIPO_LABELS = {
  CORRETIVA: 'Corretiva',
  PREVENTIVA: 'Preventiva',
  IMPLANTACAO: 'Implantação',
  RECLAMACAO: 'Reclamação',
};

export function podeIniciarOs(os) {
  return os && ['ABERTA', 'AGUARDANDO_MATERIAL'].includes(os.status);
}

export function podeFinalizarOs(os) {
  return os && ['EM_ATENDIMENTO', 'AGUARDANDO_VALIDACAO'].includes(os.status);
}

export function temSlaAtivo(os) {
  return os && os.status === 'EM_ATENDIMENTO' && !!(os.sla_horas || os.data_prazo);
}

export function getDataPrazoEfetiva(os) {
  if (!os) return null;
  if (os.data_prazo) return moment(os.data_prazo);
  if (os.sla_horas) {
    const base = os.data_inicio_atendimento || os.data_abertura;
    if (base) return moment(base).add(os.sla_horas, 'hours');
  }
  return null;
}

export function isSlaVencido(os) {
  const prazo = getDataPrazoEfetiva(os);
  return prazo ? prazo.isBefore(moment()) : false;
}

export function formatSlaRestante(os) {
  if (!temSlaAtivo(os)) return null;
  const prazo = getDataPrazoEfetiva(os);
  if (!prazo) return null;

  const diffMin = prazo.diff(moment(), 'minutes');
  const absMin = Math.abs(diffMin);
  const horas = Math.floor(absMin / 60);
  const mins = absMin % 60;
  const texto = horas > 0 ? `${horas}h ${mins}m` : `${mins}m`;

  if (diffMin < 0) return `Vencido há ${texto}`;
  return `${texto} restantes`;
}
